import { call, put, takeLatest } from 'redux-saga/effects';
import { types } from './types';
import {
    createAffiliateSuccess,
    createAffiliateFailed,
    getAffiliatesSuccess,
    getAffiliatesFailed,
    deleteAffiliateSuccess,
    deleteAffiliateFailed,
} from './actions';
import { ICreateAffiliatePayload, IGetAffiliatesPayload } from './types';
import { api } from '../../configurations/api';
import { httpRequest } from '../types';
import { affiliateUrl } from '../../configurations/api/url';
import { globalErrorHandler } from '../error/saga';
import { showToastMessage } from '../../utils/AppUtils';

// Create affiliate saga
function* createAffiliateSaga(action: { payload: ICreateAffiliatePayload }): any {
    try {
        const response = yield call(api, affiliateUrl, httpRequest.POST, action.payload, 0, 0);

        yield put(createAffiliateSuccess(response.data));
        yield call(showToastMessage, 'Affiliate code created successfully', 'success');
    } catch (error: any) {
        yield put(createAffiliateFailed(error.message || 'Failed to create affiliate'));
        yield call(globalErrorHandler, error);
    }
}

// Get affiliates saga
function* getAffiliatesSaga(action: { payload: IGetAffiliatesPayload }): any {
    try {
        const { page = 1, limit = 20 } = action.payload;
        const response = yield call(api, `${affiliateUrl}?page=${page}&limit=${limit}`, httpRequest.GET, null, 0, 0);
        yield put(getAffiliatesSuccess(response));
    } catch (error: any) {
        yield put(getAffiliatesFailed(error.message || 'Failed to get affiliates'));
        yield call(globalErrorHandler, error);
    }
}

// Delete affiliate saga
function* deleteAffiliateSaga(action: { payload: string }): any {
    try {
        yield call(api, `${affiliateUrl}/${action.payload}`, httpRequest.DELETE, {}, 0, 0);
        yield put(deleteAffiliateSuccess(action.payload));
        yield call(showToastMessage, 'Affiliate code deleted successfully', 'success');
    } catch (error: any) {
        console.log(error);
        yield put(deleteAffiliateFailed(error));
        yield call(globalErrorHandler, error);
    }
}

// Root affiliate saga
export default function* affiliateSaga() {
    yield takeLatest<any>(types.CREATE_AFFILIATE, createAffiliateSaga);
    yield takeLatest<any>(types.GET_AFFILIATES, getAffiliatesSaga);
    yield takeLatest<any>(types.DELETE_AFFILIATE, deleteAffiliateSaga);
}
